<template>
  <div class="buy-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="buy-container">
      <div class="buy-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-shopping-bag title-icon"></i>
              <div v-if="buy.length != 0">
                {{ buy.name }}
              </div>

              <div v-else>Lista de Compras</div>
            </h1>

            <p class="page-subtitle">Manipule sua lista de compras</p>
          </div>
        </div>
      </div>

      <div class="buy-content">
        <div v-if="buy.length != 0" class="content-card">
          <div class="content-wrapper">
            <div
              v-if="buy.status == 'PENDENTE' && permission('edit', 'buy')"
              class="filters-section"
            >
              <BuyUpdate :buy="buy" />
            </div>

            <div v-else class="filters-section styled-section">
              <div class="filter-item">
                <span class="filter-label">NOME DA LISTA:</span>

                <span class="filter-value">{{ buy.name }}</span>
              </div>

              <div class="filter-item">
                <span class="filter-label">TIPO DA LISTA:</span>

                <div class="filter-value">
                  <div v-if="buy.type == 'MEDICINE'" class="filter-value">
                    MEDICAMENTO
                  </div>

                  <div v-else class="filter-value">PRODUTO</div>
                </div>
              </div>

              <div class="filter-item">
                <span class="filter-label"
                  >DATA PARA A REALIZAÇÃO DA COMPRA:</span
                >

                <span v-if="buy.date_be_made" class="filter-value">{{
                  formatDate(buy.date_be_made, false)
                }}</span>

                <span v-else class="filter-value">SEM DATA CADASTRADA</span>
              </div>

              <div class="filter-item">
                <span class="filter-label"
                  >USUÁRIO RESPONSÁVEL PELA COMPRA:</span
                >

                <span class="filter-value">{{ buy.user_name }}</span>
              </div>

              <div class="filter-item">
                <span class="filter-label">ANOTAÇÃO:</span>

                <span v-if="buy.note" class="filter-value">{{ buy.note }}</span>

                <span v-else class="filter-value">SEM ANOTAÇÃO CADASTRADA</span>
              </div>

              <div class="filter-item">
                <span class="filter-label">STATUS:</span>

                <span class="filter-value">{{ buy.status }}</span>
              </div>

              <div v-if="buy.status == 'COMPRADO'">
                <div class="filter-item">
                  <span class="filter-label">DATA DA COMPRA:</span>

                  <span class="filter-value">{{
                    formatDate(buy.date_made, false)
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="content-wrapper">
            <div class="filters-section">
              <div class="add-btn-wrapper">
                <v-btn
                  v-if="buy.status != 'COMPRADO' && permission('edit', 'buy')"
                  class="btn-add-modern"
                  @click="$bvModal.show('select-item')"
                >
                  <i class="fas fa-plus mr-2"></i>
                  ADICIONAR ITENS
                </v-btn>
              </div>

              <SelectBuyItem
                @created="getBuyItens"
                :buy_id="buy.id"
                :type="buy.type"
              />

              <v-data-table
                :headers="headers"
                :items="buy_itens"
                item-key="id"
                :footer-props="{
                  'items-per-page-options': [25, 50, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
                class="modern-table"
                :no-data-text="'Nenhum Item encontrado'"
                :loading-text="'Carregando lista de itens...'"
              >
                <!-- User Column -->
                <template v-slot:[`item.user_name`]="{ item }">
                  <div class="user-cell">
                    <div class="user-avatar">
                      <img
                        v-if="item.user_photo_url"
                        :src="item.user_photo_url"
                        :alt="item.user_name"
                        class="user-photo"
                      />
                      <i v-else class="fas fa-user"></i>
                    </div>
                    <div class="user-info">
                      <span class="user-name">{{ item.user_name }}</span>
                    </div>
                  </div>
                </template>

                <template v-slot:[`item.stock_size`]="{ item }">
                  <div v-if="item.stocked_amount">
                    {{ item.stock_size }} {{ item.unit_of_measurement_name }}
                  </div>

                  <div v-else>Não cadastrado</div>
                </template>

                <template v-slot:[`item.stocked_amount`]="{ item }">
                  <div v-if="item.stocked_amount">
                    {{ item.stock_size }} {{ item.unit_of_measurement_name }}
                  </div>

                  <div v-else>Não cadastrado</div>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                  <div v-if="buy.status != 'COMPRADO'" class="actions-cell">
                    <v-btn
                      class="btn-edit-modern"
                      small
                      @click="handleUpdateBuyItem(item.id)"
                    >
                      <i class="fas fa-pen mr-1"></i>
                      Editar
                    </v-btn>

                    <confirmation-dialog
                      small
                      message-title="Retirar Item"
                      message-body="Tem certeza que deseja retirar este item da lista?"
                      open-class="btn-modern btn-modern-delete"
                      open-left-icon="fa-trash"
                      open-text="RETIRAR"
                      @yes="deleteBuyItem(item.id)"
                    />
                  </div>
                </template>
              </v-data-table>

              <BuyItemUpdate
                :buy_item_id="buy_item_id_selectd"
                @update="getBuyItens"
              />
            </div>
          </div>

          <div class="add-btn-wrapper">
            <confirmation-dialog
              v-if="
                buy.status != 'COMPRADO' &&
                buy.finished == 0 &&
                permission('remove', 'buy')
              "
              message-title="Excluir Lista de Compras"
              message-body="Tem certeza que deseja excluir esta lista de compras? Esta ação não pode ser desfeita."
              open-class="btn-modern btn-modern-delete mr-2"
              open-left-icon="fa-trash"
              open-text="EXCLUIR LISTA DE COMPRAS"
              @yes="deleteBuy(buy.id)"
            />

            <confirmation-dialog
              v-if="buy.status == 'PENDENTE' && permission('edit', 'buy')"
              headerClass="modal-header-ok"
              message-title="Deseja efetuar a lista de compras?"
              message-body="Assim que a lista for efetuada, não será possível editar informações específicas da lista."
              open-class="btn-modern btn-modern-add"
              open-left-icon="fa-check"
              open-text="EFETUAR LISTA DE COMPRAS"
              @yes="effectBuy"
            />
          </div>

          <ErrorsMessages :errors="errors" />
        </div>
        <div v-else>Lista de Compras não encontrada</div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../../templates/NavBar";

import BuyUpdate from "../../templates/Buy/BuyUpdate";

import SelectBuyItem from "../../templates/BuyItem/SelectBuyItem";

import BuyItemUpdate from "../../templates/BuyItem/BuyItemUpdate";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import ErrorsMessages from "../Components/ErrorsMessages";

import toast from "../../lib/ToastNotification";

import AuthBySessionExpired from "../../templates/Components/AuthBySessionExpired";

import routes from "../../routes";

import api from "../../services/api";

import { formatDate } from "../../lib/format";

import permission from "../../lib/permission";

export default {
  name: "BuyDetails",

  components: {
    NavBar,
    AuthBySessionExpired,
    BuyUpdate,
    SelectBuyItem,
    ConfirmationDialog,
    ErrorsMessages,
    BuyItemUpdate,
  },

  data() {
    return {
      buy_id: null,

      buy_item_id_selectd: null,

      buy: [],

      buy_itens: [],

      users: [],

      errors: [],

      headers: [
        {
          text: "CADASTRADO POR",
          value: "user_name",
          sortable: false,
        },
        {
          text: "NOME DO ITEM",
          value: "stock_name",
          sortable: false,
        },
        {
          text: "TAMANHO DO ITEM",
          value: "stock_size",
          sortable: false,
        },
        {
          text: "QUANTIDADE A COMPRAR",
          value: "quantity",
          sortable: false,
        },
        {
          text: "QUANTIDADE EM ESTOQUE",
          value: "stocked_amount",
          sortable: false,
        },
        {
          text: "AÇÕES",
          value: "action",
          sortable: false,
        },
      ],
    };
  },

  mounted() {
    this.buy_id = this.$route.params.id;

    this.getBuy();

    this.getBuyItens();
  },

  methods: {
    formatDate,
    permission,

    async getBuy() {
      try {
        this.loading = true;

        const { buy_id } = this;

        let params = { buy_id };

        const response = await api.get("/buy", {
          params,
        });

        const { buy } = response.data;

        this.buy = buy;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async getBuyItens() {
      try {
        this.loading = true;

        const { buy_id } = this;

        let params = { buy_id };

        const response = await api.get("/buy-item/buy", {
          params,
        });

        const { buy_itens } = response.data;

        this.buy_itens = buy_itens;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async effectBuy() {
      try {
        this.loading = true;

        const { buy_id } = this;

        let params = { buy_id };

        const response = await api.put("/buy/effect", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.handleToBack();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async deleteBuyItem(id) {
      try {
        this.loading = true;

        let params = {
          id,
        };

        const response = await api.delete("/buy-item", { params });

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.getBuyItens();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async deleteBuy() {
      try {
        this.loading = true;

        const id = this.buy.id;

        let params = {
          id,
        };

        const response = await api.delete("/buy", { params });

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.handleToBack();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleUpdateBuyItem(buy_item_id) {
      this.buy_item_id_selectd = buy_item_id;

      this.$bvModal.show("update-item");
    },

    handleToBack() {
      routes.go(-1);
    },
  },
};
</script>

<style scoped>
.styled-section {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}

.filter-label {
  font-weight: 600;
  color: #1e293b;
}

.filter-value {
  color: #64748b;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

.btn-save-modern {
  margin-left: auto;
}

.add-btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.buy-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.buy-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}

.buy-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
  font-size: 14px;
}

.buy-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}

.content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  min-height: 600px;
}

.content-wrapper {
  padding: 32px;
}

.content-header {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #e5e7eb;
}

.actions-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.content-title {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
}

.content-description {
  color: #64748b;
  font-size: 16px;
  margin: 0;
  line-height: 1.5;
}

.btn-edit-modern {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.25) !important;
  transition: all 0.3s ease !important;
}

.btn-edit-modern:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.35) !important;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .buy-container {
    max-width: 1200px;
  }
}

@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .buy-container {
    padding: 0 16px;
  }

  .buy-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .content-wrapper {
    padding: 24px 20px;
  }

  .content-title {
    font-size: 20px;
  }

  .content-description {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .title-icon {
    font-size: 20px;
  }

  .content-wrapper {
    padding: 20px 16px;
  }

  .content-title {
    font-size: 18px;
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .tab-item {
    min-width: 80px;
    padding: 10px 12px;
    gap: 6px;
  }

  .tab-icon {
    font-size: 14px;
  }

  .tab-label {
    font-size: 9px;
  }
}

.content-wrapper >>> .v-data-table {
  background: transparent !important;
}

.content-wrapper >>> .v-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #e5e7eb !important;
}

.content-wrapper >>> .v-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.content-card:empty::before {
  content: "Carregando...";
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #64748b;
  font-size: 16px;
}

.modern-table {
  background: transparent !important;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 16px !important;
}

.modern-table >>> .v-data-table tbody tr {
  transition: all 0.2s ease !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-table >>> .v-data-table tbody td {
  padding: 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}
</style>